/** @owner @Appboy/ai-decisioning-experience */

import { useContext } from "react";

import { DecisioningCreativeComponentLiquidContext } from "./DecisioningCreativeComponentLiquidContext";

export const useDecisioningCreativeComponentLiquidContext = () =>
  useContext(DecisioningCreativeComponentLiquidContext);
